import * as lazyIndex from './lazyIndex';
import { createLazyComponent, LazyModule } from 'owa-bundling';
import { DatapointStatus } from 'owa-analytics/lib/types/DatapointEnums';
import { getOwaLazyErrorConfig } from 'mini-error-handler/lib/utils/getOwaLazyErrorConfig';
import { MAIL_READING_PANE_LOAD_END } from 'mini-mail-workflow-tracking/lib/constants/ListViewWorkflowConstants';
import { MailReadingPaneHeaderPlaceholder } from './components/MailReadingPaneHeaderPlaceholder';
import { setDidReadingPaneHeaderLoadingFail } from 'mini-mail-placeholder-components-store/lib/actions/setDidReadingPaneHeaderLoadingFail';
import { signalWorkflowEvent } from 'mini-workflow-manager';
import { withNetworkErrorHandler } from 'mini-error-handler/lib/components/withNetworkErrorHandler';

const lazyModule = new LazyModule(() =>
    System.import<typeof lazyIndex>(/* webpackChunkName: "ReadingPane" */ './lazyIndex')
);

export const MailReadingPaneHeader = createLazyComponent(
    lazyModule,
    m => m.MailReadingPaneHeader,
    MailReadingPaneHeaderPlaceholder,
    () => setDidReadingPaneHeaderLoadingFail(true) // lazy loading failed
);

export const ReadingPane = withNetworkErrorHandler(
    null,
    getOwaLazyErrorConfig(
        lazyModule,
        m => m.ReadingPane,
        null,
        () => {
            const error = new Error('[RP] Bundle load failed');
            signalWorkflowEvent(
                MAIL_READING_PANE_LOAD_END,
                undefined,
                { isCore: true },
                { error, status: DatapointStatus.UserError }
            );
        }
    )
);
